import { inject, Injectable } from '@angular/core';
import { CustomHttpClient } from '../core/httpClient/http-client';
import { ProviderForm } from '@app/models/provider';

@Injectable({
  providedIn: 'root',
})
export class Providers {
  http = inject(CustomHttpClient);

  create(data: ProviderForm) {
    const URLEndpoint = '/providers';
    return this.http.post<{ statusCode: string; message: string }>(
      URLEndpoint,
      {
        ...data,
      },
    );
  }
}
